const state = {
  animated: true,
};
const getters = {
  isAnimated: state => {
    return state.animated;
  }
};
const mutations = {
  SET_ANIMATED(state, animated) {
    state.animated = (animated == true ? true : false);
  }
};
const actions = {
  setAnimated({
    commit
  }, animated) {
    commit('SET_ANIMATED', animated);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/animated.js